import { EHostType } from '../../types/hostType';

export const isIframeHostType = (hostType: EHostType): boolean => {
  return [EHostType.Frame, EHostType.DesktopFrame].includes(hostType);
};
